module.exports = __webpack_public_path__ + "static/linux-tux-2e82d079f8bc66df87636c7bb8f8ab7c.svg";